import React from 'react';
import { useSelector } from 'react-redux';
import {
  saveOrganizationRequest,
} from '../../../store/modules/organizations/actions';
import { useActionDispatcher } from '../../../hooks';
import { selectOrganization } from '../../../store/modules/organizations/selectors';
import BillingForm from './BillingForm';

const AccountBillingEdit = () => {
  const organization = useSelector(selectOrganization);
  const saveOrganization = useActionDispatcher(saveOrganizationRequest);

  return (
    <BillingForm
      record={organization}
      onSubmit={saveOrganization}
    />
  );
};

export default AccountBillingEdit;
